export enum Origin {
    CN = 'CN',
    HK = 'HK',
}
